/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
// import {useIntl} from 'react-intl'
// import {KTIcon} from '../../../../helpers'
// import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import { SidebarMenuItem } from './SidebarMenuItem'

type Props = {
  trrAgent?: boolean
}

const SidebarMenuMain: React.FC<Props> = ({ trrAgent }) => {
  // const intl = useIntl()

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        // icon='element-11'
        // title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        title='Dashboard'
        // fontIcon='bi-app-indicator'
        path='dashboard'
      />
      <SidebarMenuItem
        to='/profile'
        // icon='element-11'
        title='My Profile'
        path='myprofile'
      />
      <SidebarMenuItem
        to='/properties'
        // icon='element-11'
        title='My Properties'
        path='myproperties'
      />
      <SidebarMenuItem
        to='/properties/draftslisting'
        isSub
        hasBullet
        title='Draft Listing'
        // path='mydrafts'
      />
      {
        trrAgent &&
        <SidebarMenuItem
          to='/grouplisting'
          // icon='element-11'
          title='My Group Listing'
          path='mygrouplisting'
        />
      }
      <SidebarMenuItem
        to='/master'
        // icon='element-11'
        title='New Property Request'
        path='newpropertyrequest'
      />
      <SidebarMenuItem
        to='/guidance'
        // icon='element-11'
        title='My Guidance'
        path='myguidance'
      />
      <SidebarMenuItem
        to='/package-subscription'
        // icon='element-11'
        title='Package Subsciption'
        path='packagesubscribe'
      />
      <SidebarMenuItem
        to='/payment-history'
        // icon='element-11'
        title='Payment History'
        path='paymenthistory'
      />

      {/******* do not remove this reference *******/}
      {/* <div className='menu-item'>
        <div className='menu-content pt-8 pb-2'>
          <span className='menu-section text-muted text-uppercase fs-8 ls-1'>Crafted</span>
        </div>
      </div>
      <SidebarMenuItemWithSub
        to='/crafted/pages'
        title='Pages'
        fontIcon='bi-archive'
        icon='element-plus'
      >
        <SidebarMenuItemWithSub to='/crafted/pages/profile' title='Profile' hasBullet={true}>
          <SidebarMenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
          <SidebarMenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
          <SidebarMenuItem
            to='/crafted/pages/profile/campaigns'
            title='Campaigns'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/documents'
            title='Documents'
            hasBullet={true}
          />
          <SidebarMenuItem
            to='/crafted/pages/profile/connections'
            title='Connections'
            hasBullet={true}
          />
        </SidebarMenuItemWithSub>

        <SidebarMenuItemWithSub to='/crafted/pages/wizards' title='Wizards' hasBullet={true}>
          <SidebarMenuItem
            to='/crafted/pages/wizards/horizontal'
            title='Horizontal'
            hasBullet={true}
          />
          <SidebarMenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
        </SidebarMenuItemWithSub>
      </SidebarMenuItemWithSub> */}
      {/******* do not remove this reference *******/}
    </>
  )
}

export { SidebarMenuMain }
